module.exports = __webpack_public_path__ + "static/media/06.0b02a62e.png";